import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Row, Col, message, Typography, Checkbox } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useAuthStore } from '../store/authStore';
import { themeColors } from '../config/theme';

const { Title, Text } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((state) => state.login);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const authError = useAuthStore((state) => state.error);

  // Redirect to dashboard if already logged in
  useEffect(() => {
    console.log('🔍 Login page - isAuthenticated:', isAuthenticated);
    if (isAuthenticated) {
      console.log('✅ Redirecting to dashboard...');
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (values) => {
    console.log('📝 Form submitted with values:', values);
    setLoading(true);
    try {
      const success = await login(values.email, values.password, values.rememberMe);
      setLoading(false);

      if (success) {
        console.log('✅ Login successful, navigating...');
        message.success('Login successful!');
        navigate('/dashboard', { replace: true });
      } else {
        console.log('❌ Login returned false');
        message.error(authError || 'Login failed. Check your credentials.');
      }
    } catch (err) {
      console.error('💥 Submit error:', err);
      setLoading(false);
      message.error('An error occurred during login');
    }
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{
        minHeight: '100vh',
        backgroundColor: themeColors.bg,
        padding: '20px',
      }}
    >
      <Col xs={24} sm={20} md={12} lg={8}>
        <Card
          style={{
            backgroundColor: themeColors.bgElevated,
            borderColor: themeColors.border,
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img
              src="/cloudnet-logo.png"
              alt="CloudNet"
              style={{
                height: '80px',
                marginBottom: '20px',
                objectFit: 'contain',
              }}
            />
            <Title level={1} style={{ color: themeColors.primary, margin: 0 }}>
              CloudNet
            </Title>
            <Text style={{ color: themeColors.textSecondary }}>
              Billboard Management System
            </Text>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            onFinishFailed={(errorInfo) => {
              console.error('❌ Form validation failed:', errorInfo);
            }}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Invalid email format' },
              ]}
            >
              <Input
                prefix={<UserOutlined style={{ color: themeColors.primary }} />}
                placeholder="Email"
                size="large"
                style={{
                  backgroundColor: themeColors.bg,
                  borderColor: themeColors.border,
                  color: themeColors.text,
                }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: themeColors.primary }} />}
                placeholder="Password"
                size="large"
                style={{
                  backgroundColor: themeColors.bg,
                  borderColor: themeColors.border,
                }}
              />
            </Form.Item>

            <Form.Item name="rememberMe" valuePropName="checked" initialValue={false}>
              <Checkbox style={{ color: themeColors.textSecondary }}>
                Remember me for 30 days
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
                style={{
                  backgroundColor: themeColors.primary,
                  borderColor: themeColors.primary,
                }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Text style={{ color: themeColors.textSecondary, fontSize: '13px' }}>
              Are you a client?{' '}
              <a
                href={process.env.REACT_APP_CLIENT_PORTAL_URL}
                style={{ color: themeColors.primary }}
              >
                Log in to the Client Portal
              </a>
            </Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
}
